import React from 'react';
import { Link } from 'react-router-dom';
import useMediaQuery from '../hooks/useMediaQuery';

const T = {
  paper:      '#F7EFD8',
  ink2:       '#4A3510',
  rule:       '#D7C9A1',
  ruleStrong: '#BFAB79',
  orange:     '#EA7C1F',
  r3:         '10px',
  sans:       '"Nunito", ui-sans-serif, system-ui, -apple-system, sans-serif',
};

export const PUBLIC_NAV_HEIGHT = 73; // px — keep in sync with nav padding + logo height

/**
 * Shared top nav for all public (logged-out) pages.
 *
 * `onGetStarted` — optional click handler for the "Get started" button;
 *   defaults to navigating to /.
 */
const PublicNav = ({ onGetStarted }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      <nav style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: isMobile ? '16px 24px' : '20px 64px',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        backgroundColor: T.paper,
        borderBottom: `1px solid ${T.rule}`,
        fontFamily: T.sans,
      }}>
        <Link to="/" style={{ display: 'block', lineHeight: 0 }}>
          <img src="/text-logo.png" alt="Cahoots" style={{ height: 32, width: 'auto', display: 'block' }} />
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 12 : 28 }}>
          {!isMobile && (
            <>
              <a href="/#how-it-works" style={linkStyle}>How it works</a>
              <a href="/#pricing" style={linkStyle}>Pricing</a>
              <Link to="/blog" style={linkStyle}>Blog</Link>
              <Link to="/contact" style={linkStyle}>Contact</Link>
            </>
          )}

          {onGetStarted ? (
            <button onClick={onGetStarted} style={ctaStyle}>
              Get started
            </button>
          ) : (
            <Link to="/" style={{ ...ctaStyle, textDecoration: 'none' }}>
              Get started
            </Link>
          )}
        </div>
      </nav>
      {/* Spacer so fixed nav doesn't overlap page content */}
      <div style={{ height: PUBLIC_NAV_HEIGHT }} />
    </>
  );
};

const linkStyle = {
  fontSize: 14,
  fontWeight: 600,
  color: T.ink2,
  textDecoration: 'none',
};

const ctaStyle = {
  fontSize: 14,
  fontWeight: 700,
  color: '#fff',
  backgroundColor: T.orange,
  border: 'none',
  borderRadius: '10px',
  padding: '8px 16px',
  cursor: 'pointer',
};

export default PublicNav;
